import React, { memo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  Grid,
  Typography,
  NativeSelect,
  InputLabel,
  FormControl,
  CircularProgress,
  Stack,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import configServ from "../../../services/config";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import AddLineItem from "../../masterEntry/ItemEditOptions/AddLineItem";
import useDebounce from "../../hooks/useDebounce";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchBox from "../../Search/SearchBox";
import ItemLedgerPopup from "../../Inventory/ItemLedgerPopup";
import { useLocation } from "react-router-dom";

import useDeviceDetect from "../../../Components/Detect/useDeviceDetect ";
import { cellStyle, evenRowStyle, headerCellStyle, oddRowStyle, rowStyle } from "../../../utility/CustomStyle";

//FUNCTION
const ItemTable = ({ handleEdit, isChanged, pagination = true }) => {
  //#region code
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const rowsPerPageOptions = [20, 50, 100, 200];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[1]);
  const [itemList, setItemList] = useState([]);
  //const [filterItemList, setFilterItemList] = useState([]);
  const [searchBy, setSearchBy] = useState("item_name");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  // const [openGenerateLineItems, setOpenGenerateLineItems] = useState(false);
  // const [lineItem, setLineItem] = useState({});
  const [openItemLedger, setOpenItemLedger] = useState(false);
  const [itemLedger, setItemLedger] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemLedgerLoading, setItemLedgerLoading] = useState(true);

  const location = useLocation();
  const [redirectItemName, setRedirectItemName] = useState(location.state);

  const { isMobile } = useDeviceDetect();

  useEffect(() => {
    if (redirectItemName) {
      setSearchBy("item_name");
      setSearch(redirectItemName);
      fetchItemList("item_name", redirectItemName);
    } else {
      setSearchBy("item_name");
      setSearch("");
    }
  }, [redirectItemName]);

  useEffect(() => {
    if (!redirectItemName) {
      fetchItemList();
    }
  }, [isChanged, page, rowsPerPage]);

  useEffect(() => {
    if (!redirectItemName) {
      if (page === 0) {
        fetchItemList();
      } else {
        setPage(0);
      }
    }
  }, [debounceSearch]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const fetchItemList = async (searchByItem = null, ItemName = null) => {
    try {
      setLoading(true);
      const dataToSend = {
        company_id: company_id,
        search_by: searchByItem ? searchByItem : searchBy,
        search: ItemName ? ItemName : debounceSearch,
        per_page: rowsPerPage,
        page: page,
      };
      const res = await configServ.getItemList(dataToSend);
      if (res.status === 200) {
        const result = res.data;
        if (result.length > 0) {
          setItemList(result);
          setCount(res.total);
        }
        else{
          setItemList([]);
          setCount(0);
        }
      }
    } 
    catch (e) {
      console.log(e);
    } 
    finally {
      setLoading(false);
    }
  };

  const headers = [
    "PAIN AREA",
    "CODE",
    "BRAND",
    "CATEGORY",
    "SUBCATEGORY",
    "STATUS",
    "ACTION",
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleItemLedger = async (params) => {
    try {
      setOpenItemLedger(true);
      const item = itemList.find((x) => x.id === params);
      const dataToSend = {
        item_id: params,
        //per_page: 10,
        //page: 0
      };
      const res = await configServ.getItemLedger(dataToSend);
      if (res.status === 200) {
        setItemLedger(res.data);
        setSelectedItem(item);
      } else {
        setItemLedger([]);
        setSelectedItem(null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setItemLedgerLoading(false);
    }
  };

  const handleItemLedgerClose = () => {
    setOpenItemLedger(false);
    setItemLedger([]);
    setSelectedItem(null);
    setItemLedgerLoading(true);
  };

  //#endregion

  return (
    <>
      <ItemLedgerPopup
        openItemLedger={openItemLedger}
        handleItemLedgerClose={handleItemLedgerClose}
        itemLedger={itemLedger}
        selectedItem={selectedItem}
        itemLedgerLoading={itemLedgerLoading}
      />

      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-start"
        sx={{ pt: 1 }}
        spacing={1}
        direction={"row"}
      >
        <Grid item xs={12} md={6} ml={0} justifyContent={"flex-start"}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Pain Areas: {count}
          </Typography>
        </Grid>
        {redirectItemName ? (
          <>
            <Grid container item xs={12} md={6} justifyContent={"flex-end"}>
              <Button
                variant="contained"
                title="Referesh"
                color="success"
                startIcon={<RefreshIcon sx={{ ml: 1, color: "white" }} />}
                onClick={() => {
                  setRedirectItemName(null);
                }}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} md={3}>
              <Box sx={{ minWidth: 120, marginLeft: "0px" }}>
                <FormControl fullWidth>
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    Search By
                  </InputLabel>
                  <NativeSelect
                    defaultValue={"contact_name"}
                    onChange={handleSearchBy}
                    inputProps={{
                      name: "searchBy",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={"item_name"}>Pain Area</option>
                    <option value={"category"}>Category</option>
                    <option value={"group_name"}>Sub-Category</option>
                  </NativeSelect>
                </FormControl>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              mr={{ xs: 0, md: 0 }}
              justifyContent={"flex-end"}
            >
              <SearchBox search={search} setSearch={setSearch} />
            </Grid>
          </>
        )}
      </Grid>

      {isMobile ? (
        <>
          <Grid container spacing={2}>
            {loading ? (
              <Grid item xs={12} textAlign="center">
                <CircularProgress />
              </Grid>
            ) : itemList.length > 0 ? (
              itemList.map((row, rowIndex) => (
                <Grid item xs={12} key={rowIndex}>
                  <Paper elevation={3} sx={{ p: 2 }}>
                    <Stack spacing={1}>
                      <Box sx={{ fontWeight: "bold" }}>
                        {page * rowsPerPage + rowIndex + 1}. {row.item_name}
                      </Box>
                      <Box> <strong>Code:</strong> {row.item_code}</Box>
                      <Box> <strong>Brand:</strong> {row.brand}</Box>
                      <Box> <strong>Category: </strong> {row.category}</Box>
                      <Box> <strong>Sub-Category:</strong> {row.group_name}</Box>
                      <Box>
                        Status:{" "}
                        {row.status === 1 ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <CancelIcon color="error" />
                        )}
                      </Box>
                      <Box>
                        <Stack direction="row">
                          <EditIcon
                            sx={{
                              borderRadius: 10,
                              width: "fit-content",
                              transition: "100ms",
                              cursor: "pointer",
                              padding: 0,
                              m: 0.5,
                              ":hover": { backgroundColor: "#99999955" },
                            }}
                            color="primary"
                            onClick={() => {
                              handleEdit(row);
                              scrollToTop();
                            }}
                          />
                          {/* <VisibilityIcon
                            sx={{
                              borderRadius: 10,
                              width: "fit-content",
                              transition: "100ms",
                              cursor: "pointer",
                              padding: 0,
                              m: 0.5,
                              ":hover": { backgroundColor: "#99999955" },
                            }}
                            color="primary"
                            onClick={() => handleItemLedger(row.id)}
                          /> */}
                        </Stack>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              ))
            ) : (
              <Grid item xs={12} textAlign="center">
                <Box sx={{ color: "red", fontWeight: 600 }}>No data found.</Box>
              </Grid>
            )}
          </Grid>
          {pagination && (
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      ) : (
        <>
          <TableContainer component={Paper} sx={{ py: 1 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellStyle}>S.No.</TableCell>
                  {headers.map((header, index) => (
                    <TableCell key={index} sx={headerCellStyle}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {loading === true ? (
                <TableRow>
                  <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                    <Box>
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                <TableBody>
                  {itemList.length > 0 ? (
                    itemList.map((row, rowIndex) => (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          ...rowStyle,
                          ...(rowIndex % 2 === 0 ? evenRowStyle : oddRowStyle),
                        }}
                      >
                        <TableCell sx={cellStyle}>
                          {page * rowsPerPage + rowIndex + 1}
                        </TableCell>
                        <TableCell sx={cellStyle}>{row.item_name}</TableCell>
                        <TableCell sx={cellStyle}>{row.item_code}</TableCell>
                        <TableCell sx={cellStyle}>{row.brand}</TableCell>
                        <TableCell sx={cellStyle}>{row.category}</TableCell>
                        <TableCell sx={cellStyle}>
                          {row.group_name}
                        </TableCell>
                        <TableCell sx={cellStyle}>
                          {row.status === 1 ? (
                            <CheckCircleIcon color="success" />
                          ) : (
                            <CancelIcon color="error" />
                          )}
                        </TableCell>
                        <TableCell sx={cellStyle}>
                          <Stack direction={"row"}>
                            <EditIcon
                              sx={{
                                borderRadius: 10,
                                width: "fit-content",
                                transition: "100ms",
                                cursor: "pointer",
                                padding: 0,
                                m: 0.5,
                                ":hover": { backgroundColor: "#99999955" },
                              }}
                              color="primary"
                              onClick={() => {
                                handleEdit(row);
                                scrollToTop();
                              }}
                            />
                            {/* <VisibilityIcon
                              sx={{
                                borderRadius: 10,
                                width: "fit-content",
                                transition: "100ms",
                                cursor: "pointer",
                                padding: 0,
                                m: 0.5,
                                ":hover": { backgroundColor: "#99999955" },
                              }}
                              color="primary"
                              onClick={() => handleItemLedger(row.id)}
                            /> */}
                            {/* 
                            <Tooltip title='Generate Line Item' placement='top' arrow>
                              <IconButton onClick={()=>handleLineItems(row)} sx={{'&hover':{backgroundColor:'#99999955'}}}>
                              <Inventory2Icon color='secondary'/>
                              </IconButton>
                            </Tooltip> 
                            */}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                        <Box sx={{ color: "red", fontWeight: 600 }}>
                          No data found.
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
            {pagination && (
              <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </TableContainer>
        </>
      )}
    </>
  );
};

export default memo(ItemTable);
